<template>
  <div>
    <!-- 演示系统 -->
    <div class="document-container">
      <div class="document-right">
        <div class="document-content-pallet">

          <div>

            <div class="larry-block">
              <h1 class="fly-docs-title" style="text-align: center;margin-top: 20px"><img class="image" src="../assets/img/logo5.png" width="56"/>系统演示</h1>
              <div style="margin-left: 12.5%">
                <div id="docsIndexDiv">
                  <div class="layui-text layui-doc-index">
                    <p><strong>1、管理后台</strong></p>
                    <p>
                      访问地址：
                      <a href="https://admin.fswan.cn/#/login" target="_blank">https://admin.fswan.cn</a>
                      账号：admin   密码：123456
                    </p>
                    <p><strong>2、其他需求</strong><br/></p>
                    <p>
                      如有特殊需求，可联系作者沟通协商（微信或电话：18976205160）。<br/>
                    </p>
                    <p><strong>3、注意事项</strong><br/></p>
                    <p>
                      演示环境可随意测试。请不要任意删除账号或改动密码，以免影响他人测试。<br/>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <h1 class="fly-docs-title" style="margin-top: 200px;text-align: center">系统介绍</h1>
            <div class="center pro-text">
              <p>
                fswan财务软件是一款轻量级的财务管理系统，功能完善、系统安全稳定、简单易用、支持多账套创建，满足您多方位的财务管理需求。
              </p>
            </div>

            <div id="subject">
              <div id="subject-content" class="flex-column">
                <!-- 每一个文章和配置板块
                配图在左 -->
                <div class="flex-row-re img-left product-all">
                  <!-- PC展现 -->
                  <img src="../assets/img/A001.png" class="hidden subject-img"/>
                  <!-- H5展现 -->
                  <img src="../assets/img/A001.png" class="none H5-de-img"/>
                  <div class="subject-text">
                    <p class="h3">【账套管理】</p>
                    <p class="describe">
                      账套管理：系支持多账套创建使用，账套之间数据隔离不相互影响，登录后首页进入账套选择页面，需要选择账套后才可以操作系统其他功能。
                    </p>
                    <p class="subject-abso">
                      <a href="#" class="trans-rihgt">更多功能查看系统演示</a>
                      <img src="../assets/img/right.svg"/>
                    </p>
                  </div>
                </div>

                <!-- 配图在右 -->
                <div class="flex-row img-right">
                  <!-- PC展现 -->
                  <img src="../assets/img/A002.png" class="hidden subject-img"/>
                  <!-- H5展现 -->
                  <img src="../assets/img/A002.png" class="none H5-de-img"/>
                  <div class="subject-text">
                    <p class="h3">【凭证信息】</p>
                    <p class="describe">
                      凭证信息：包含凭证管理、凭证汇总表、科目余额表、明细账等功能。
                    </p>
                    <p class="subject-abso">
                      <a href="#" class="trans-rihgt" style="margin-left: 20px">更多功能查看系统演示</a>
                      <img src="../assets/img/right.svg"/>
                    </p>
                  </div>
                </div>

                <!-- 每一个文章和配置板块
                配图在左 -->
                <div class="flex-row-re img-left product-all">
                  <img src="../assets/img/A003.png" class="hidden subject-img"/>
                  <img src="../assets/img/A003.png" class="none H5-de-img"/>
                  <div class="subject-text">
                    <p class="h3">【常用报表】</p>
                    <p class="describe">
                      财务报表：包含资产负载表、利润表、现金流量表，报表支持按账期实时查询，并提供报表导出功能。
                    </p>
                    <p class="subject-abso">
                      <a href="" class="trans-rihgt">更多功能查看系统演示</a>
                      <img src="../assets/img/right.svg"/>
                    </p>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "sysVue",
    props: {}
  };
</script>